import { EnvEnum } from '../common/types/common'

export const AZ_STORAGE_ACCOUNT_URL_DASHBOARD = process.env
  .REACT_APP_AZ_STORAGE_ACCOUNT_URL_DASHBOARD as string
export const ENVIRONMENT = (process.env.REACT_APP_ENVIRONMENT ?? EnvEnum.DEV) as EnvEnum
export const MICROSOFT_ENTRA_CLIENT_ID = process.env.REACT_APP_MICROSOFT_ENTRA_CLIENT_ID as string
export const SENTRY_CONFIG_PROFILES_SAMPLE_RATE = Number(
  process.env.REACT_APP_SENTRY_CONFIG_PROFILES_SAMPLE_RATE ?? 0,
)
export const SENTRY_CONFIG_TRACES_SAMPLE_RATE = Number(
  process.env.REACT_APP_SENTRY_CONFIG_TRACES_SAMPLE_RATE ?? 0,
)
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN as string
export const WEB_APP_URL_DASHBOARD_BACKEND = process.env
  .REACT_APP_WEB_APP_URL_DASHBOARD_BACKEND as string
export const WEB_APP_URL_PROCESS_API = process.env.REACT_APP_WEB_APP_URL_PROCESS_API as string
export const WEB_APP_URL_CONFIG_STUDIO_API = process.env
  .REACT_APP_WEB_APP_URL_CONFIG_STUDIO_API as string
export const WEB_APP_URL_CORE_LOGIC_API = process.env.REACT_APP_WEB_APP_URL_CORE_LOGIC_API as string
export const WEB_APP_URL_DASHBOARD_FRONTEND = process.env
  .REACT_APP_WEB_APP_URL_DASHBOARD_FRONTEND as string

